import gql from 'graphql-tag'
import api from './apiClient'
import { runSubscription } from '../subscriptor/order'

export default {
  readTotal: emisor =>
    api
      .send({
        query: gql`
          query readTotal($emisor: ID!) {
            Order {
              readTotal(emisor: $emisor)
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Order.readTotal),

  readAllByEmisor: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readAllByEmisor($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Order {
              readAllByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  _idDoc
                  user {
                    _id
                    username
                  }
                  userSession {
                    _id
                    username
                  }
                  receptor {
                    _id
                    nombre
                    nombreComercial
                    telefono {
                      numTelefono
                    }
                    correoElectronico
                    ubicacion {
                      provincia {
                        id
                      }
                      canton {
                        id
                      }
                      distrito {
                        id
                      }
                      otrasSenas
                      lat
                      long
                    }
                  }
                  consecutivo
                  factura
                  _idFactura
                  status
                  details
                  startDate
                  endDate
                  createdAt
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Order.readAllByEmisor),

  readById: _id =>
    api
      .send({
        query: gql`
          query readById($_id: ID!) {
            Order {
              readById(_id: $_id) {
                user {
                  _id
                }
                itemOrder {
                  _id
                  detalle
                  cantidad
                }
                totalComprobante
                medioPago {
                  id
                }
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Order.readById),

  readBySearchString: (emisor, searchString) =>
    api
      .send({
        query: gql`
          query readBySearchString($emisor: ID!, $searchString: String!) {
            Order {
              readBySearchString(emisor: $emisor, searchString: $searchString) {
                feed {
                  _id
                  _idDoc
                  user {
                    _id
                    username
                  }
                  userSession {
                    _id
                    username
                  }
                  receptor {
                    _id
                    nombre
                    nombreComercial
                    telefono {
                      numTelefono
                    }
                    correoElectronico
                    ubicacion {
                      provincia {
                        id
                      }
                      canton {
                        id
                      }
                      distrito {
                        id
                      }
                      otrasSenas
                      lat
                      long
                    }
                  }
                  consecutivo
                  factura
                  _idFactura
                  status
                  details
                  startDate
                  endDate
                  createdAt
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          searchString
        }
      })
      .then(result => result.data.data.Order.readBySearchString),

  readByDateRange: (emisor, inicio, final) =>
    api
      .send({
        query: gql`
          query readByDateRange($emisor: ID!, $inicio: Date, $final: Date) {
            Order {
              readByDateRange(emisor: $emisor, inicio: $inicio, final: $final) {
                feed {
                  _id
                  _idDoc
                  user {
                    _id
                    username
                  }
                  userSession {
                    _id
                    username
                  }
                  receptor {
                    _id
                    nombre
                    nombreComercial
                    telefono {
                      numTelefono
                    }
                    correoElectronico
                    ubicacion {
                      provincia {
                        id
                      }
                      canton {
                        id
                      }
                      distrito {
                        id
                      }
                      otrasSenas
                      lat
                      long
                    }
                  }
                  consecutivo
                  factura
                  _idFactura
                  status
                  details
                  startDate
                  endDate
                  createdAt
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          inicio,
          final
        }
      })
      .then(result => result.data.data.Order.readByDateRange),

  create: input =>
    api
      .send({
        query: gql`
          mutation create($input: OrderInput!) {
            Order {
              create(input: $input)
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Order.create),

  subscriptionNewOrder: (emisor, fn) =>
    runSubscription(
      {
        query: gql`
          subscription newOrder($emisor: ID!) {
            newOrder(emisor: $emisor) {
              _id
              _idDoc
              receptor {
                _id
                nombre
                nombreComercial
                telefono {
                  numTelefono
                }
                correoElectronico
                ubicacion {
                  provincia {
                    id
                  }
                  canton {
                    id
                  }
                  distrito {
                    id
                  }
                  otrasSenas
                  # lat
                  # long
                }
              }
              consecutivo
              factura
              _idFactura
              status
              details
              startDate
              endDate
              createdAt
            }
          }
        `,
        variables: {
          emisor
        }
      },
      (err, result) => {
        if (!err) fn(result.data.newOrder)
      }
    )
}
